import SectionHeader from "../SectionHeader/SectionHeader";
import styles from "./About.module.css";
import { aboutPoints } from "./About.controller";

const About = () => {
  return (
    <section className={styles.section} id="about">
      <SectionHeader
        eyebrow="Why QIMAH"
        title="We blend strategy, design, and engineering into one seamless team."
        description="Precision meets creativity - our squads move fast, communicate clearly, and keep you in the loop with transparent milestones."
      />

      <div className={styles.grid}>
        {aboutPoints.map((point) => (
          <div key={point.title} className={styles.panel}>
            <h3>{point.title}</h3>
            <p>{point.description}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default About;
